import { searchContacts } from '../infrastructure/adapters/contactService';
import { useSearch } from '@/shared/composables/useSearch';
export function useContacts(tableQuery, filtersReady, ast, refinement) {
    const { items: contacts, pageResponse, loading, loadError, loadErrorCode, reload } = useSearch(searchContacts, tableQuery, 'contacts', { waitFor: filtersReady, ast, refinement });
    return { contacts, pageResponse, loading, loadError, loadErrorCode, reload };
}
